import { FC, useState } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { ConnectFacebookDialogStepKind, connectFacebookDialogSteps } from './Steps'

type Props = {
  isOpen: boolean
  onClose: VoidFunction
  showIntroStep?: boolean
}

export const ConnectInstagramAccountDialog: FC<Props> = ({ isOpen, onClose, showIntroStep }) => {
  const [step, setStep] = useState<ConnectFacebookDialogStepKind>(showIntroStep ? 'intro' : 1)
  const handleForwardStep = () =>
    setStep((prev) => {
      switch (prev) {
        case 'intro':
          return 1
        case 5:
          return 5 // 最後のステップの場合は何もしない
        default:
          return (prev + 1) as ConnectFacebookDialogStepKind
      }
    })

  const handleBackStep = () =>
    setStep((prev) => {
      switch (prev) {
        case 'intro':
          return 'intro'
        case 1:
          return showIntroStep ? 'intro' : 1
        default:
          return (prev - 1) as ConnectFacebookDialogStepKind
      }
    })

  const handleClose = () => {
    onClose()
    setTimeout(() => {
      setStep(showIntroStep ? 'intro' : 1)
    }, 500)
  }

  return (
    <Dialog open={isOpen} maxWidth="md" fullWidth>
      <DialogTitle sx={{ fontWeight: 'bold', color: 'primary.dark' }}>
        {typeof step === 'number' && <span style={{ display: 'block', color: 'black' }}>Step:{step}/5</span>}
        <span>{connectFacebookDialogSteps[step].title}</span>
      </DialogTitle>
      <DialogContent>{connectFacebookDialogSteps[step].content}</DialogContent>
      <DialogActions sx={{ justifyContent: 'space-between' }}>
        <Button sx={{ color: 'grey.600' }} onClick={handleClose}>
          今はしない
        </Button>
        <Box sx={{ display: 'flex', gap: 2 }}>
          {step !== 'intro' && (step !== 1 || showIntroStep) && (
            <Button onClick={handleBackStep}>前のステップに戻る</Button>
          )}
          {step === 5 ? (
            <Button variant="contained" onClick={handleClose}>
              閉じる
            </Button>
          ) : (
            <Button variant="contained" onClick={handleForwardStep}>
              次のステップへ
            </Button>
          )}
        </Box>
      </DialogActions>
    </Dialog>
  )
}
